// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PricingHistoryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Published global pricing rows, newest-first — GET /ai/credits/pricing/history.
 * Full-gated only.
 */
import type { AiCredits_PricingHistoryRow } from './AiCredits_PricingHistoryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PricingHistoryResponseDados {
rows: AiCredits_PricingHistoryRow[]
}

export type AiCredits_PricingHistoryResponse = ApiResponse<AiCredits_PricingHistoryResponseDados>;

registerResponseContract('AiCredits_PricingHistoryResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                    { type: 'number',  required: true },
      model_name:            { type: 'string',  required: true },
      cache_hit_usd_per_1m:  { type: 'string',  required: true },
      cache_miss_usd_per_1m: { type: 'string',  required: true },
      output_usd_per_1m:     { type: 'string',  required: true },
      valid_from:            { type: 'string',  required: true },
      valid_to:              { type: 'string',  required: false },
    },
  },
})
